import React from 'react';
import './card-numerico.css'

interface CardNumericoProps {
  textoSuperior: React.ReactNode
  textoCentral: React.ReactNode
  textoInferior: React.ReactNode
}

export const CardNumerico: React.FC<CardNumericoProps> = (props) => {
  return <div className="card-numerico">
    <div className="card-numerico-top">{props.textoSuperior}</div>
    <div className="card-numerico-middle">{props.textoCentral}</div>
    <div className="card-numerico-down">{props.textoInferior}</div>
  </div>
}
